module.exports = __webpack_public_path__ + "img/92.2d23fa42.png";